<template>
    <div>

        <div class="container is-fluid">
            <div class="app-block">
                <transition name="component-fade" mode="out-in">
                    <div class="section has-text-justified">

                        <router-link class="button"
                                     :to="{ path: '/admissionsup/'+school+'/mon-compte'}">
                            <span class="icon is-small"><i class="fa fa-chevron-left"></i></span> <span class="has-text-weight-bold">Retour à ma Candidature</span>
                        </router-link>

                        <h3 class="has-text-centered title is-4"><span>CONTRAT DE SCOLARITE DIDEROT EDUCATION</span>
                        </h3>

                        <div>
                            <div>

                                <div class="m-b-md has-text-justified" v-html="page.body.intro"></div>

                                <h4>Et l'étudiant:</h4><br>
                                <p>Nom: <strong>{{ candidate.last_name }}</strong>
                                </p>
                                <p>Prénom: <strong>{{ candidate.first_name }}</strong>
                                </p>
                                <p>Né(e) le: <strong>{{ formatDate(candidate.birthday) }}</strong>
                                </p>
                                <p>Adresse: <strong>{{ candidate.address }} {{ candidate.post_code }} {{ candidate.city }}</strong>
                                </p>
                                <p>E-mail: <strong>{{ candidate.email }}</strong>
                                </p><br>
                                <p>Ci-aprés dénommé(e)<strong>"le candidat" </strong>ou <strong>"</strong><strong>l'étudiant",</strong>
                                </p>
                            </div>


                            <div class="m-t-lg p-b-lg" v-html="page.body.page"></div>


                            <div class="diderot-signatures">
                                <div class="left">
                                    <img :src="'/docs/diderot-stamp.png'" width="250">
                                </div>
                                <div class="right">
                                    <img :src="'/docs/diderot-signature.jpg'" height="120">
                                </div>

                            </div>
                        </div>

                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import api from 'services/organization'

    export default {
        data () {
            return {
                school: '',
                page: {
                    id: 3,
                    title: 'Contrat de scolarité',
                    body: {}
                },
            }
        },
        computed: {
            ...mapGetters({
                candidate: 'candidate/getSingleCandidate'
            }),
            ...mapState({
                user: 'auth',
                application: 'application',

            })
        },
        methods: {
            formatDate(date) {
                return moment(date, 'YYYY-MM-DD HH:mm').format('LL')
            },
        },
        created () {
            if (this.$route.params.school) {
                this.school = this.$route.params.school
            }
            api.page(6).then((result) => {
                this.page.body = JSON.parse(result.data.body)
            }).catch((err) => {
                this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
            })
        }
    }
</script>

<style scoped>
    em {
        color: #000;
    }

    .diderot-signatures {
        width: 60%;
        height: 10em;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }
</style>
